<template>
<div class="editor" style="flex-grow: 1">
  <div style="display: flex; margin: 1.2em 0;" v-for="(value, key, index) in data" :key="key">
    <label style="flex-shrink: 0">{{isArr(data) ? Number(key + 1) : key}}</label>:
    <template v-if="typeof value !== 'object'">
      <textarea v-if="typeof value !== 'boolean'" style="flex-grow: 1; font-size: 14px" v-model="data[key]"></textarea>
      <input type="checkbox" v-else v-model="data[key]"></input>
    </template>
    <template v-else><editor :data="data[key]"></editor></template>
  </div>
</div>
</template>

<script>
export default {
  name: 'editor',
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
    isArr (obj) {
      return Array.isArray(obj)
    }
  }
}
</script>

<style scoped>
.editor {
  background: #000;
  cursor: default;
  color: #fff;
}
.editor textarea {
  width: 100%;
  background-color: #000;
  color: #fff;
  border: 1px solid #55f;
  border-radius: 10px;
  margin: 0 10px;
  padding: 3px 8px;
  text-shadow: 0 0 3px blueviolet
}
</style>



// WEBPACK FOOTER //
// src/components/editor/editor.vue